import React, { Component, useState } from 'react';
import { connect, } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { autoLoginQRSession, login, register } from 'actions/auth';
import { withRouter } from '../withRouter';
import styles from '../Forms/FormStyles.module.scss'
import { Link, createSearchParams } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import QRLogin from "components/Roku/QRLogin/QRLogin"
import AuthService from "services/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
//import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
//import FacebookLogin from 'react-facebook-login';
import { faGoogle, faApple } from '@fortawesome/free-brands-svg-icons';
import DotLoader from 'components/Utlility/DotLoader';

class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            loading: false,
            rememberMe: false,
            showMainNav: false,
            errorMessage: "",
            width: window.innerWidth,
            view: "loginOrSignUp",
        };
    }

    updateWindowSize = () => {
        this.setState({ width: window.innerWidth });
    };

    async componentWillMount() {
        window.addEventListener('resize', this.updateWindowSize);
        const appleRedirectURI = window.location.origin + "/login";
        console.log("appleRedirectURI: ", appleRedirectURI);
        if (window.AppleID) {
            window.AppleID.auth.init({
                clientId: "com.gamecity.web", // Your service ID from Apple
                scope: "name email",
                redirectURI: appleRedirectURI,
                usePopup: true, // Important to prevent full redirect
            });
        }

        const searchParams = new URLSearchParams(window.location.search);
        const QRSessionID = searchParams.get("QRSessionID");

        this.setState({ QRSessionID: QRSessionID });
        if (this.props.auth.isLoggedIn) {
            if (QRSessionID) {
                const UserID = this.props.auth.user.id;
                this.setState({ loading: true });
                await this.props.autoLoginQRSession(QRSessionID, UserID);
                this.setState({ loading: true });
                return setTimeout(() => this.props.navigate(`/join/?QRSessionID=${QRSessionID}`));
            }
            return setTimeout(() => this.props.navigate("/"));
        } else {
            const rememberMe = localStorage.getItem("rememberMe");
            const email = localStorage.getItem("email");

            if (rememberMe === true) {
                this.setState({ rememberMe, email });
            }
        }
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowSize);
    }

    onChangeEmail = (e) => {
        const email = e.target.value;

        this.setState({ email });
    };

    onChangePassword = (e) => {
        const password = e.target.value;
        const validLength = password.length >= 8;
        const hasNumber = (/\d/g).test(password);
        const upperCase = (/[A-Z]/g).test(password);
        const lowerCase = (/[a-z]/g).test(password);
        this.setState({ password, validLength, hasNumber, upperCase, lowerCase });
    };

    checkAccountExists = (e) => {
        e.preventDefault();
        if (this.state.loading) return;
        this.setState({ loading: true, errorMessage: "" });
        const email = this.state.email;
        AuthService.checkAccountExists(email)
            .then((res) => {
                if (res.message === true) this.setState({ view: "login" })
                else if (res.message === false) this.setState({ view: "register" })
                else this.setState({ errorMessage: "Something whent wrong" });
            }).catch((err) => {
                this.setState({ errorMessage: err });
            }).finally(() => {
                this.setState({ loading: false });
            })
    }

    handleLoginViaEmail = (e) => {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({ loading: true, errorMessage: "" });

            const email = this.state.email;
            const password = this.state.password;

            if (this.state.rememberMe) {
                localStorage.setItem('rememberMe', this.state.rememberMe);
                localStorage.setItem('email', email);
            }

            const req = {
                provider: "none",
                email: email,
                password: password,
                QRSessionID: this.state.QRSessionID,
                country: this.props.pricing.countryCode
            };
            this.props.login(req)
                .then((res) => {
                    console.log(res);
                    this.onLogin(this.state.QRSessionID);
                })
                .catch((err) => {
                    this.setState({ loading: false, errorMessage: err });
                });
        }
    };

    onQRLogin = (QRSessionID) => {
        this.props.navigate(`/lobby/?QRSessionID=${QRSessionID}`);
    }

    onLogin = (QRSessionID = null) => {
        if (this.props.modal) {
            this.props.closeModal(true);
        } else {
            const returnURL = new URLSearchParams(window.location.search).get("returnURL");
            console.log("return url : ", returnURL);
            if (returnURL) {
                this.props.navigate(decodeURIComponent(returnURL));
            } else {
                if (QRSessionID) this.props.navigate(`/join/?QRSessionID=${QRSessionID}`);
                else this.props.navigate("/");
            }
        }
    }

    handleRegisterViaEmail = (e) => {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({ loading: true, errorMessage: "", });
            if (this.validate()) {
                const email = this.state.email;
                const password = this.state.password;
                this.props.register(email, password, this.props.pricing.countryCode)
                    .then((res) => {
                        console.log(res);
                        this.props.login({ provider: "none", email: email, password: password, QRSessionID: this.state.QRSessionID, country: this.props.pricing.countryCode })
                            .then((res) => {
                                console.log(res);
                                this.onLogin(this.state.QRSessionID);
                            })
                            .catch((err) => {
                                this.setState({ loading: false });
                            });
                    })
                    .catch((err) => {
                        console.log("register err: ", err);
                        this.setState({ loading: false, errorMessage: err, });
                    });
            } else {
                this.setState({ loading: false, });
                this.setState({ errorMessage: "This password doesn't meet the minimum requirements", });
            }
        }
    };

    validate = () => {

        if (!this.state.validLength || !this.state.hasNumber || !this.state.upperCase || !this.state.lowerCase) {
            return false;
        }

        return true;
    }

    onGoogleLogin = (responce) => {
        this.setState({ loading: true, errorMessage: "" });
        console.log("Do Google Login")
        console.log(responce)
        const idToken = responce.access_token;
        const req = {
            provider: "Google",
            idToken: idToken,
            QRSessionID: this.state.QRSessionID,
            country: this.props.pricing.countryCode
        };
        console.log(JSON.stringify(req));
        this.props.login(req)
            .then((res) => {
                console.log(res);
                this.onLogin(this.state.QRSessionID);
            })
            .catch((err) => {
                this.setState({ loading: false });
            });
    }

    handleAppleLogin = () => {
        if (window.AppleID) {
            window.AppleID.auth.signIn().then((response) => {
                // Send to backend for token exchange
                this.onAppleLogin(response.authorization.code);
            }).catch(err => {
                console.error("Apple login error", err);
                this.setState({ errorMessage: "Apple login failed." });
            });
        }
    };

    onAppleLogin = (authCode) => {
        // This will depend on how your backend handles Apple login
        this.setState({ loading: true, errorMessage: "" });
        console.log("Apple auth code: " + authCode);
        const req = {
            provider: "Apple",
            idToken: authCode,
            QRSessionID: this.state.QRSessionID,
            country: this.props.pricing.countryCode
        }
        console.log("Apple login request: ");
        console.log(JSON.stringify(req))
        this.props.login(req)
            .then((res) => {
                console.log(res);
                this.onLogin(this.state.QRSessionID);
            }).catch((err) => {
                this.setState({ loading: false, errorMessage: err });
            });
    };

    onFacebookLogin = (response) => {
        this.setState({ loading: true, errorMessage: "" });
        const req = {
            provider: "Facebook",
            idToken: response.accessToken,
            QRSessionID: this.state.QRSessionID,
            country: this.props.pricing.countryCode
        };
        this.props.login(req)
            .then((res) => {
                console.log(res);
                this.onLogin(this.state.QRSessionID);
            })
            .catch((err) => {
                this.setState({ loading: false });
            });
    }

    render() {
        return (
            <>
                <div id="" className={styles.columns}>
                    {
                        (window.innerWidth > 780 && !this.state.QRSessionID) &&
                        <>
                            <div id="leftColumn" className={`${styles.column} ${styles.qrWrapper}`}>
                                <QRLogin onLogin={this.onQRLogin} color="black" textStyle={{ color: "black" }}></QRLogin>
                            </div>
                            <div className={`${styles.verticalDivider} `} style={{ marginRight: '40px' }} />
                        </>
                    }
                    <div id="rightColumn" className={styles.column}>
                        {this.state.view === "loginOrSignUp" &&
                            <Form onSubmit={this.checkAccountExists} className={styles.fadeIn}>
                                <h3 className={styles.formTitle}>Login or Sign up</h3>
                                <div className="mb-2">
                                    {/*<GoogleLogin onSuccess={(e) => this.onGoogleLogin(e)} onError={() => console.log("Login Failed")} />*/}
                                    <GoogleLoginButton onSuccess={(res) => this.onGoogleLogin(res)} onError={() => console.log("Login Failed")} disabled={this.state.loading} />
                                </div>
                                <div className="mb-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-dark w-100 mb-2"
                                        onClick={this.handleAppleLogin}
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                                        disabled={this.state.loading}
                                    >
                                        <FontAwesomeIcon icon={faApple} style={{ marginRight: 8 }} />
                                        Sign in with Apple
                                    </button>
                                </div>
                                {/*<div className="mb-2">*/}
                                {/*    <FacebookLogin appId="1088597931155576" autoLoad={true} fields="name,email" callback={this.onFacebookLogin} />*/}
                                {/*</div>*/}
                                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                                    <hr style={{ flex: 1, border: 'none', opacity: 1, borderTop: '3px solid lightgray' }} />
                                    <span style={{ padding: '0 10px', whiteSpace: 'nowrap' }}>Continue with email</span>
                                    <hr style={{ flex: 1, border: 'none', opacity: 1, borderTop: '3px solid lightgray' }} />
                                </div>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="email" placeholder="Enter email" required onChange={this.onChangeEmail} />
                                </Form.Group>

                                {/*<Form.Group className="mb-3" controlId="formBasicPassword">*/}
                                {/*    <Form.Label>Password</Form.Label>*/}
                                {/*    <Form.Control type="password" placeholder="Password" required onChange={this.onChangePassword} />*/}
                                {/*</Form.Group>*/}
                                {
                                    this.state.errorMessage.length > 0 &&
                                    <Alert variant={"danger"}>
                                        {this.state.errorMessage}
                                    </Alert>
                                }

                                <div className={`${styles.buttonsWrapper} mt-3`}>
                                    {/*<button className={`${styles.button} ${styles.alternate}`} type="button" onClick={() => this.goToRegister()} style={{ marginRight: '10px' }} disabled={!this.state.email}>Register</button>*/}
                                    <button className={styles.button} type="submit" disabled={!this.state.email}>{this.state.loading ? <DotLoader size="medium" variant="light" /> : "Login / register"}</button>
                                </div>

                                <Link to={"/forgot-password"} className={`${styles.passwordForget}`}>
                                    <p>Forgot your password?</p>
                                </Link>
                            </Form>
                        }
                        {this.state.view === "login" &&

                            <Form onSubmit={this.handleLoginViaEmail} className={styles.fadeIn} >
                                <button type="button" className={styles.backButton} onClick={() => this.setState({ view: "loginOrSignUp" })} aria-label="Back">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <h3 className={styles.formTitle}>Login</h3>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control value={this.state.email} type="email" placeholder="Enter email" required onChange={this.onChangeEmail} disabled />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Control autoFocus type="password" placeholder="Password" required onChange={this.onChangePassword} />
                                </Form.Group>
                                {
                                    this.state.errorMessage.length > 0 &&
                                    <Alert variant={"danger"}>
                                        {this.state.errorMessage}
                                    </Alert>
                                }

                                <div className={`${styles.buttonsWrapper} mt-3`}>
                                    {/*<button className={`${styles.button} ${styles.alternate}`} type="button" onClick={() => this.goToRegister()} style={{ marginRight: '10px' }} disabled={!this.state.email}>Register</button>*/}
                                    <button className={styles.button} type="submit" disabled={!this.state.email || this.state.loading}>{this.state.loading ? <DotLoader size="medium" variant="light" /> : "Login"}</button>
                                </div>

                                <Link to={"/forgot-password"} className={`${styles.passwordForget}`}>
                                    <p>Forgot your password?</p>
                                </Link>
                            </Form>
                        }
                        {this.state.view === "register" &&
                            <Form onSubmit={this.handleRegisterViaEmail} className={styles.fadeIn}>
                                <button type="button" className={styles.backButton} onClick={() => this.setState({ view: "loginOrSignUp" })} aria-label="Back">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <h3 className={styles.formTitle}>Register </h3>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="email" value={this.state.email} placeholder="Enter email" required onChange={this.onChangeEmail} />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Control autoFocus autoComplete="none" className="mb-2" type="password" placeholder="Password" required onChange={this.onChangePassword} isInvalid={this.state.password.length > 0 && (!this.validate())}></Form.Control>
                                    <ul className={styles.passwordRequirements}>
                                        <li className={this.state.password.length > 0 && (this.state.validLength ? "text-success" : "text-danger")}>
                                            Your password must be at least 8 characters
                                        </li>
                                        <li className={this.state.password.length > 0 && (this.state.hasNumber ? "text-success" : "text-danger")}>
                                            Your password must include a number
                                        </li>
                                        <li className={this.state.password.length > 0 && (this.state.upperCase ? "text-success" : "text-danger")}>
                                            Your password must include an upper case letter
                                        </li>
                                        <li className={this.state.password.length > 0 && (this.state.lowerCase ? "text-success" : "text-danger")}>
                                            Your password must include a lower case letter
                                        </li>
                                    </ul>
                                </Form.Group>
                                {
                                    this.state.errorMessage.length > 0 &&
                                    <Alert variant={"danger"}>
                                        {this.state.errorMessage}
                                    </Alert>
                                }

                                <div className={`${styles.buttonsWrapper} mt-3`}>
                                    {/*<button className={`${styles.button} ${styles.alternate}`} type="button" onClick={() => this.goToRegister()} style={{ marginRight: '10px' }} disabled={!this.state.email}>Register</button>*/}
                                    <button className={styles.button} type="submit" disabled={!this.validate()}>
                                        {this.state.loading ? <DotLoader size="medium" variant="light" /> : "Register"}
                                    </button>
                                </div>

                                <Link to={"/forgot-password"} className={`${styles.passwordForget}`}>
                                    <p>Forgot your password?</p>
                                </Link>
                            </Form>
                        }
                    </div>
                </div>
                <br />
                <div className={styles.termsContainer} >
                    By logging in or registering you are agreeing to the <Link to="/terms">Game.City Terms</Link>
                </div>
            </>
        );
    }
}

const GoogleLoginButton = ({ onSuccess, onError, disabled }) => {
    const login = useGoogleLogin({
        onSuccess: (responce) => onSuccess(responce),
        onError: (error) => onError(error),
        scope: "openid email profile",
    });

    return (
        <button
            type="button"
            className="btn btn-outline-primary w-100 mb-2"
            onClick={() => login()}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            disabled={disabled}
        >
            <FontAwesomeIcon icon={faGoogle} style={{ marginRight: 8 }} />
            Sign in with Google
        </button>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        login: (req) => {
            return dispatch(login(req))
        },
        autoLoginQRSession: (QRSessionID, UserID) => {
            return dispatch(autoLoginQRSession(QRSessionID, UserID))
        },
        register: (email, password, country) => {
            return dispatch(register(email, password, country))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
